/**
 * Downloads a file with the given filename and base64 data
 * @param fileName The name of the file to download
 * @param data Base64 data that came from the endpoint
 */
export const downloadFile = (fileName: string, data: string): void => {
  const a = document.createElement("a");
  a.href = `data:application/octet-stream;base64,${data}`;
  a.download = `${fileName}.pdf`;
  a.click();
};
